import React from "react";
import Lottie from "lottie-react";
import whatsappAnimation from "../animations/whatsapp.json";

/**
 * Login Animation Component
 *
 * Displays the real official WhatsApp animated logo on the login page
 * Uses authentic WhatsApp animation from LottieFiles
 */
const LoginAnimation = ({ size = 120 }) => {
  return (
    <div
      style={{
        width: size,
        height: size,
        margin: "0 auto",
      }}
      className="login-animation"
    >
      <Lottie animationData={whatsappAnimation} loop={true} autoplay={true} />
    </div>
  );
};

export default LoginAnimation;
